import React, { useState, useEffect } from "react";
import "../../RolloverBike/planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axiosInstance from "../../../Redux/axios/AxiosInstance";
import {
  quick_quotes_Bike,
  QuickQuote_Post,
  Err_quotes,
} from "../../../Redux/actions/NumBikeation";
// import axios from "axios";
import { Button, Form, Radio, message } from "antd/lib";

export default function CustomerType({ setisModalOwner }) {
  const dispatch = useDispatch();
  const QuickQuotes = useSelector(
    (state) => state.vehicledetail.quickquotes.data
  );
  console.log("QuickQuotes", QuickQuotes);
  const QuickQuotePost = useSelector(
    (state) => state.vehicledetail.quickQuotePost
  );
  const auth = useSelector((state) => state.vehicledetail.bikenum);
  const [QuotePost, setQuotePost] = useState(QuickQuotePost);
  const [loading, setLoading] = useState(false);

  const onFinish = (data) => {
    console.log("data", data);
    // console.log("dateString",data.registrationDate)
    const updatedQuotePost = {
      ...QuickQuotePost,
      partnertype: data?.partnertype,
      //   vehicle_core_code: BikeMakeData?.VehicleCoreCode,
      //   rto_code: BikeMakeData?.selected_rto,
    };
    console.log(updatedQuotePost);
    setLoading(true);
    axiosInstance
      .post(
        `bike_insurances/insurance_types/new/quick_quotes`,
        updatedQuotePost
      )
      .then((res) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          const errData = data?.filter(
            (item) => "status" in item && item.status === "failed"
          );
          dispatch(Err_quotes(errData));
          const filteredData = data?.filter(
            (item) => "status" in item && item.status === "success"
          );
          dispatch(quick_quotes_Bike(filteredData));
          dispatch(QuickQuote_Post(updatedQuotePost));
          setLoading(false);
          setisModalOwner(false);
          // } else {
          // setLoading(false)
          // message.error(res.data.error.validationMessages.join(","));
          // }
        }
      })
      .catch((err) => {
        console.log(err.response.data.error);
        setLoading(false);
        message.error(err.response.data.error);
      });
  };
  return (
    <>
      <Form onFinish={onFinish} layout="vertical" requiredMark={false}>
        <Form.Item
          // className="form-item-bg"
          name="partnertype"
          label="Choose the Customer Type"
          rules={[
            {
              required: true,
              message: "Please select",
            },
          ]}
          initialValue={QuotePost?.partnertype}
        >
          <Radio.Group
            className="py-3 px-3 bg-white ant-radio-layout"
            style={{
              width: "100%",
            }}
          >
            <Radio value="INDIVIDUAL">Individual</Radio>
            <Radio value="COMPANY">Company</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item style={{ textAlign: "center" }}>
          <Button
            type="primary"
            loading={loading}
            htmlType="submit"
            className="update-qut-button"
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
